import BoardUserRole from '@pkgs/shared/enums/BoardUserRole';

const PRIVILEGE_TO_ROLES_MAP = {
	[BoardUserRole.VIEWER]: [
		BoardUserRole.VIEWER,
		BoardUserRole.EDITOR,
		BoardUserRole.ADMIN,
		BoardUserRole.OWNER,
	],
	[BoardUserRole.EDITOR]: [BoardUserRole.EDITOR, BoardUserRole.ADMIN, BoardUserRole.OWNER],
	[BoardUserRole.ADMIN]: [BoardUserRole.ADMIN, BoardUserRole.OWNER],
	[BoardUserRole.OWNER]: [BoardUserRole.OWNER],
};

export default function boardUserRoleHasBoardUserRolePrivileges(
	boardUserRole: ValueOf<typeof BoardUserRole> | undefined | null,
	boardUserRoleToCheck: ValueOf<typeof BoardUserRole>,
) {
	if (boardUserRole) {
		return (PRIVILEGE_TO_ROLES_MAP[boardUserRoleToCheck] as readonly ValueOf<typeof BoardUserRole>[]).includes(boardUserRole);
	}

	return false;
}
